import { LogoIcon } from '~/components/common/logo';
import { PersonIcon } from '@radix-ui/react-icons';

export default function ChatAvatar({ role }: { role: string }) {
  if (role === 'user') {
    return (
      <div className="flex h-8 w-8 shrink-0 select-none items-center justify-center rounded-md border bg-background shadow">
        <PersonIcon className="h-4 w-4" />
      </div>
    );
  }

  return (
    <div className="flex h-8 w-8 shrink-0 select-none items-center justify-center rounded-md border bg-black text-white shadow">
      <LogoIcon className="fill-white" SVGAttributes={{ className: 'h-4 w-4' }} />
    </div>
  );
}
